import { Box, Grid, GridItem, Text } from '@chakra-ui/react'
import React, { memo } from 'react'
import { ProductItem } from './ProductItem'
import { Link, useNavigate } from 'react-router-dom'
import {
  useAllProductListQuery,
  useProductListQuery,
} from 'common/api/domains/goods/goodsQuery'
import ProductCarousel from 'views/goods/ProductCarousel'
import { useLatestNoticeQuery } from 'common/api/domains/profile/profileQuery'

export const CategoryListMobile = memo(() => {
  const navigate = useNavigate()

  const handleNavigate = () => {
    navigate('/management/profile/notice-list')
  }
  const { data: products, isLoading: productsLoading, error: productsError } = useAllProductListQuery()
  const { data: latestNotice, isLoading: noticeLoading } = useLatestNoticeQuery()
  
  // 캐시 키
  const mainProductsKey = 'main_products_data';

  // 데이터 로딩 처리
  if (productsLoading) {
    // 캐시된 데이터 사용 시도
    try {
      const cachedProducts = localStorage.getItem(mainProductsKey);
      if (cachedProducts) {
        const parsedProducts = JSON.parse(cachedProducts);
        if (parsedProducts && parsedProducts.length > 0) {
          return renderProductList(parsedProducts);
        }
      }
    } catch (e) {
      console.warn('캐시 데이터 로드 실패', e);
    }
    
    return <Box>로딩 중...</Box>;
  }
  
  // 에러 처리
  if (productsError) {
    // 캐시된 데이터 사용 시도
    try {
      const cachedProducts = localStorage.getItem(mainProductsKey);
      if (cachedProducts) {
        const parsedProducts = JSON.parse(cachedProducts);
        if (parsedProducts && parsedProducts.length > 0) {
          return renderProductList(parsedProducts);
        }
      }
    } catch (e) {
      console.warn('캐시 데이터 로드 실패', e);
    }
    
    return <Box>데이터를 불러오는데 실패했습니다.</Box>;
  }
  
  // 데이터가 있다면 캐시에 저장
  if (products && products.length > 0) {
    try {
      localStorage.setItem(mainProductsKey, JSON.stringify(products));
    } catch (e) {
      console.warn('캐시 데이터 저장 실패', e);
    }
  }
  
  // 제품 데이터가 없는 경우
  if (!products || products.length === 0) {
    return <Box>상품이 없습니다.</Box>;
  }

  // 제품 목록 렌더링 함수
  function renderProductList(productList: any[]) {
    return (
      <Box
        w={'100%'}
        display={'flex'}
        justifyContent={'center'}
        flexDirection={'column'}
        alignItems={'center'}
      >
        <Box w={'360px'}>
          <Text my={4} fontSize={20} fontWeight={'bold'}></Text>
        </Box>
        {/* 상품 슬라이더 */}
        <ProductCarousel />
        <Box h={'32px'} />

        <Text
          fontSize={14}
          textAlign={'start'}
          onClick={handleNavigate}
          cursor="pointer"
          paddingX={2}
        >
          {latestNotice?.title || '공지사항이 없습니다.'}
        </Text>
        <Box h={'32px'} />
        <Grid templateColumns={'repeat(2,1fr)'} gap={3} justifyContent={'center'}>
          {productList
            .filter((product) => product.is_main_display)
            .sort((a, b) => a.main_seq - b.main_seq)
            .map((product, index) => (
              <GridItem key={index}>
                <Link to={`/goods/products/${product.id}`}>
                  <ProductItem product={product} />
                </Link>
              </GridItem>
            ))}
        </Grid>
      </Box>
    );
  }
  
  return renderProductList(products);
})
